<div class="menu-container" [ngClass]="{ 'menu-container-reponsive': isResponsive }">
  <div class="menu-header">
    <div class="menu" (click)="toggleResponsive(!isResponsive)">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <p class="title">CERS</p>
  </div>
</div>
@if (isResponsive) {
<div @sidenavAnim @fadeAnim class="aa-tab-bar clearfix navbar"
  [ngClass]="{ five: menuService.items.admin.active, four: !menuService.items.admin.active }">
  <div class="user">
    <p>{{ user.firstName }},</p>
    <p>{{ user.lastName }}</p>
    <p>{{ user.id }}</p>
  </div>
  <ul class="nav sidenav" [ngClass]="{ responsive: isResponsive }">
    <li routerLink="home" routerLinkActive="active">
      <a>
        <div>{{ menuService.items.home.text }}</div>
      </a>
    </li>
    <li routerLink="newreport" routerLinkActive="active">
      <a>
        <div>{{ menuService.items.newreport.text }}</div>
      </a>
    </li>

    <li routerLink="reporthistory" routerLinkActive="active">
      <a>
        <div>{{ menuService.items.reporthistory.text }}</div>
      </a>
    </li>

    <li routerLink="todo" routerLinkActive="active" *appFeatureFlag="todoFeatureFlag">
      <a>
        <div>{{ menuService.items.todo.text }}</div>
      </a>
    </li>
    @if (isAdminUser) {
    <li>
      <button type="button" (click)="toggleAdminMenu()">
        <span class="text-decoration-underline">{{ menuService.items.admin.text }}</span>
        <span class="admin-toggle-chevron" [ngClass]="
                isAdminMenuExpanded
                  ? 'sec-caret-up icon-sec-caret-up-fill'
                  : 'sec-caret-down icon-sec-caret-down-fill'
              " aria-hidden="true"></span>
      </button>
    </li>
    @if (isAdminMenuExpanded && isCategoryUser) {
    <li routerLink="admin/categorymanagement" routerLinkActive="active">
      <a>
        <div class="indented">Category Management</div>
      </a>
    </li>
    }
    @if (isAdminMenuExpanded && isPrivilegeUser) {
    <li routerLink="admin/privilegemanagement" routerLinkActive="active">
      <a>
        <div class="indented">Privilege Management</div>
      </a>
    </li>
    }
    @if (isAdminMenuExpanded && isTagUser) {
    <li routerLink="admin/tagmanagement" routerLinkActive="active">
      <a>
        <div class="indented">Tag Management</div>
      </a>
    </li>
    }
    }
    <!-- disabling offline-sync for the time being
      <li routerLink="{{menuService.items.offlinesync.route}}" routerLinkActive="active" *ngIf="isPwa">
        <a>
          <div>{{menuService.items.offlinesync.text}}</div>
        </a>
      </li> -->
    <li routerLink="help" routerLinkActive="active">
      <a>
        <div>Help</div>
      </a>
    </li>
    <li>
      <a>
        <div routerLink="/logout">Logout</div>
      </a>
    </li>
    @if (isProxyMenuItem && isProxyUser && !(proxyMode$ | async)) {
    <li (click)="proxyMenuItemHide()" class="proxy">
      <a>
        <div>Proxy</div>
      </a>
    </li>
    }
    @if (isProxyMenuItemInput && isProxyUser && !(proxyMode$ | async)) {
    <li class="proxy">
      <a (click)="proxyMenuItemShow()">
        <div>Proxy</div>
        <div class="user-search-control" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          <input type="text" placeholder="Enter user id" [(ngModel)]="proxyUserId" (keyup.enter)="loadProxyUser()" />
          <button (click)="loadProxyUser()">Go</button>
        </div>
      </a>
    </li>
    }
    @if (proxyMode$ | async) {
    <li>
      <a>
        <div (click)="exitProxyMode()">Exit Proxy Mode</div>
      </a>
    </li>
    }
  </ul>
</div>
}
@if (isResponsive) {
<div @fadeAnim class="overlay" (click)="close()"></div>
}
